let paymentStatusSorts = []
let paymentInfoStatusSorts = []
// 缴费逾期限制功能位图
let appLimitBitMap = ['消费', '门禁通行', '图书借阅']

export default {
  paymentStatusSorts,
  paymentInfoStatusSorts,
  appLimitBitMap
}



// WEBPACK FOOTER //
// ./src/store/payment/state.js